import {Button, Grid, Typography} from '@material-ui/core';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import locale from '../locale/Localization';
import DocumentForm from './DocumentForm';

const styles = {
  root: {
    width: '100%'
  },
  title: {
    paddingTop: '20px',
    paddingBottom: '20px',
    color: 'white'
  },
  button: {
    marginTop: '20px',
    color: 'white'
  }
};

/**
 * Component class of DocumentDetails
 */
export default class DocumentDetails extends Component {
  /**
   * Creates a DocumentDetails
   *
   * @param {Object} props - the property data
   */
  constructor(props) {
    super(props);
    this.state = {
      documentId: props.documentId
    };
  }

  componentDidMount = () => {
    // this.fetchDocumentDetails(this.props.documentDetails.id);
  };

  /**
   * Renders document's details page
   *
   * @return {string} - details page to be rendered
   */
  renderDetails = () => {
    return (
      <div id='document-details-container' style={styles.root}>
        <DocumentForm
          archiveAccess={this.props.archiveAccess}
          documentId={this.props.documentId}
          handleDocumentSubmit={this.props.handleDocumentSubmit}
        />
      </div>
    );
  };

  /**
   * Renders DocumentDetails component
   *
   * @return {string} - document details component to be rendered
   */
  render() {
    return (
      <div>
        <Grid container item xs={12} spacing={3}>
          <Grid item xs={10}>
            <Button
              style={styles.button}
              size='small'
              onClick={() => {
                this.props.onBackLinkClick();
              }}
              startIcon={<ArrowBackIosOutlinedIcon />}
            >
              {locale.back}
            </Button>
          </Grid>
        </Grid>
        <Typography variant='h5' gutterBottom style={styles.title}>
          {locale.documentDetailsPageTitle}
        </Typography>
        {this.state.documentId && this.renderDetails()}
      </div>
    );
  }
}

DocumentDetails.propTypes = {
  archiveAccess: PropTypes.string.isRequired,
  handleDocumentSubmit: PropTypes.func.isRequired,
  documentId: PropTypes.string.isRequired,
  onBackLinkClick: PropTypes.func.isRequired,
  setClick: PropTypes.func
};
